import { all, fork } from 'redux-saga/effects';
import eventWatcher from './watchers/eventWatcher';
import authWatcher from './watchers/authWatcher';
import layoutSaga from './watchers/layoutWatcher';
import userWatcher from './watchers/userWatcher';
import pvsWatcher from './watchers/pvsWatcher';
import awardsWatcher from './watchers/awardsWatcher';

export default function* rootSaga() {
  yield all([
    fork(eventWatcher),
    fork(awardsWatcher),
    fork(authWatcher),
    fork(layoutSaga),
    fork(userWatcher),
    fork(pvsWatcher),
    // Add other watchers here
  ]);
}
